import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/google-icon.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Settings", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"840px"} }, null, -1)
const _hoisted_3 = { class: "dialog-content mt-3 pb-4" }
const _hoisted_4 = { class: "dialog-card mx-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "section-title mb-3" }, "Basic Info", -1)
const _hoisted_6 = { class: "settings-dialog__item" }
const _hoisted_7 = { class: "u" }
const _hoisted_8 = { class: "input-group mt-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-divider my-3" }, null, -1)
const _hoisted_10 = { class: "settings-dialog__item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, "Password", -1)
const _hoisted_12 = { class: "input-group mt-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "on-desktop" }, null, -1)
const _hoisted_14 = { class: "input-group mt-3" }
const _hoisted_15 = { class: "dialog-card mx-0 mr-0 pb-0" }
const _hoisted_16 = { class: "dialog-card mx-0" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "section-title mb-3" }, "Log in with your social account", -1)
const _hoisted_18 = { class: "settings-dialog__social" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "socialName" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("div", null, "Google")
], -1)
const _hoisted_20 = { class: "settingsSocial flex" }
const _hoisted_21 = { style: {"display":"none"} }
const _hoisted_22 = { class: "no-hover" }
const _hoisted_23 = { class: "hover" }

import { computed, reactive } from 'vue';
import { useAccountStore } from '@/stores/account';
import { useErrors } from '@/utils/use-errors';
import { useConfirmModal } from '@/stores/confirm-modal';
import { useToastStore } from '@/stores/toast';
import VButton from '../VButton.vue';
import VTabs from '../VTabs.vue';
import VInput from '../VInput.vue';
import AddIcon from '../icons/other/AddIcon.vue';
import CheckIcon from '../icons/other/CheckIcon.vue';
import DisconnectIcon from '../icons/other/DisconnectIcon.vue';
import ConnectedSocialPages from '@/components/ConnectedSocialPages.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsDialog',
  props: {
    page: null
  },
  setup(__props: any) {

const props = __props as { page?: "profile" | "social"}



const accountStore = useAccountStore()

const ui = reactive({ 
  changeEmail: false, 
  changePassword: false, 
  pendingChangeLogin: false, 
  pendingChangePassword: false 
})

const toastStore = useToastStore()

const values = reactive<{ 
  email?: string,
  new_password?: string, 
  new_password_repeat?: string,
  password?: string 
}>({})
const { errors, checkRequired } = useErrors(values)

const changePassword = async () => {
  if (!checkRequired([ "new_password", "password" ])) return
  if (values["new_password"] !== values["new_password_repeat"]) {
    errors["new_password_repeat"] = "Passwords do not match"
    return
  }
  ui.pendingChangePassword = true
  try {
    await accountStore.changePassword(values.password!, values.new_password!, values.new_password_repeat!)
    ui.changePassword = false
    values.new_password = ""
    values.password = ""
    values.new_password_repeat = ""
    toastStore.showToast("Password changed", "success")
  } catch(e: any) {
    if (e.body && e.body[0]?.field in values) {
      errors[e.body[0]?.field] = e.body[0].message
    } else {
      errors["new_password"] = e.body?.message || "An error has occurred"
    }
  } finally {
    ui.pendingChangePassword = false 
  }
}

const changeEmail = async () => {
  if (!checkRequired([ "email", "password" ])) return

  ui.pendingChangeLogin = true
  try {
    await accountStore.changeEmail(values.email!, values.password!)
    ui.changeEmail = false
    values.email = ""
    values.password = ""
    toastStore.showToast("A confirmation email was sent")
  } catch(e: any) {
    if (e.body && e.body[0]?.field in values) {
      errors[e.body[0]?.field] = e.body[0].message
    } else {
      errors["email"] = e.body?.message || "An error has occurred"
    }
  } finally {
    ui.pendingChangeLogin = false 
  }
}

const confirmModal = useConfirmModal()
const connectedSocial = computed(() => ({
  facebook: accountStore.currentUser?.networks.includes('facebook'),
  google: accountStore.currentUser?.networks.includes('google')
}))
const toggleGoogle = (e: MouseEvent) => {
  if (connectedSocial.value.google) {
    confirmModal.open(e, "Are you sure you want to disable?", async () => {
      await accountStore.disconnectGoogleAuth()
    })
  } else {
    accountStore.authByGoogle()
  }
}

const toggleFacebook = (e: MouseEvent) => {
  if (connectedSocial.value.facebook) {
    confirmModal.open(e, "Are you sure you want to disable?", async () => {
      await accountStore.disconnectFacebookAuth()
    })
  } else {
    accountStore.authByFacebook()
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(VTabs, {
        pages: { profile: 'Profile', social: 'Assets', signin: 'Social sign-in' },
        "start-page": props.page,
        "with-router": ""
      }, {
        profile: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createTextVNode("Your email address is "),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(accountStore).currentUser?.email), 1)
              ]),
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (ui.changeEmail = !ui.changeEmail))
              }, _toDisplayString(ui.changeEmail? "Hide": "Change"), 1)
            ]),
            (ui.changeEmail)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(VInput, {
                      modelValue: values.email,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((values.email) = $event)),
                      class: "min",
                      label: "New Email",
                      placeholder: "Enter new email",
                      error: _unref(errors).email
                    }, null, 8, ["modelValue", "error"]),
                    _createVNode(VInput, {
                      modelValue: values.password,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((values.password) = $event)),
                      class: "min",
                      label: "Current Password",
                      placeholder: "Enter current password",
                      type: "password",
                      error: _unref(errors).password
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  _createVNode(VButton, {
                    secondary: "",
                    class: "mt-3",
                    disabled: ui.pendingChangeLogin,
                    onClick: changeEmail
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Update")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ], 64))
              : _createCommentVNode("", true),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (ui.changePassword = !ui.changePassword))
              }, _toDisplayString(ui.changePassword? "Hide": "Change"), 1)
            ]),
            (ui.changePassword)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(VInput, {
                      modelValue: values.password,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((values.password) = $event)),
                      class: "min",
                      label: "Current Password",
                      placeholder: "Enter current password",
                      type: "password",
                      error: _unref(errors).password
                    }, null, 8, ["modelValue", "error"]),
                    _hoisted_13
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(VInput, {
                      modelValue: values.new_password,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((values.new_password) = $event)),
                      class: "min",
                      label: "New Password",
                      placeholder: "Enter new password",
                      type: "password",
                      error: _unref(errors).new_password
                    }, null, 8, ["modelValue", "error"]),
                    _createVNode(VInput, {
                      modelValue: values.new_password_repeat,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((values.new_password_repeat) = $event)),
                      class: "min",
                      label: " ",
                      placeholder: "Retype new password",
                      type: "password",
                      error: _unref(errors).new_password_repeat
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  _createVNode(VButton, {
                    secondary: "",
                    class: "mt-3",
                    disabled: ui.pendingChangePassword,
                    onClick: changePassword
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Update")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        social: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(ConnectedSocialPages)
          ])
        ]),
        signin: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(connectedSocial).google? "Connected": "Not connected"), 1),
                (_unref(connectedSocial).google)
                  ? (_openBlock(), _createBlock(VButton, {
                      key: 0,
                      class: "connected",
                      onClick: toggleGoogle
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_22, [
                          _createVNode(CheckIcon),
                          _createTextVNode("Connected")
                        ]),
                        _createElementVNode("span", _hoisted_23, [
                          _createVNode(DisconnectIcon),
                          _createTextVNode("Disconnect")
                        ])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(VButton, {
                      key: 1,
                      onClick: toggleGoogle
                    }, {
                      default: _withCtx(() => [
                        _createVNode(AddIcon),
                        _createTextVNode("Connect")
                      ]),
                      _: 1
                    }))
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["start-page"])
    ])
  ], 64))
}
}

})